/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../../components/AdminModal';
import TextInput from '../../../../components/input';
import useForm from '../../../../customHooks/useForm';
import useToast from '../../../../customHooks/useToast';
import { ADMIN_EDIT_ROLES, REMOVE_MEMBER_FROM_ROLE } from '../../../../graphql/admin_mutations';
// import ModalFormComp from '../../../../components/ModalFormComp';

import RoundMinusIcon from '../../../../svgs/RoundMinusIcon';
import Styles from './RemoveMemeber.module.scss';

interface IRemoveMemberRole{
  onClose:any;
  payload:any;
  activeRoleId:any;
  refetch:any;

}
const RemoveMemberRole = ({
  onClose, payload, activeRoleId, refetch,
}:IRemoveMemberRole) => {
  const Toast = useToast();
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [removeMemeber, { loading: removeMemberLoading }] = useMutation<
  { removeMemberFromRole: any },
  any
  >(REMOVE_MEMBER_FROM_ROLE);

  const {
    formValues, handleChange,
  } = useForm(
    {
      reason: '',
    },
    {},
    Toast,
  );

  const removeMemeberFromRole = async () => {
    const data = {
      adminId: payload?.id,
      roleId: activeRoleId?.id,
    };
    if (!removeMemberLoading) {
      try {
        const res = await removeMemeber({
          variables: data,
        });

        if (res?.data?.removeMemberFromRole && res?.data?.removeMemberFromRole?.status === 200) {
          setIsSuccessful(true);
          refetch();
        } else {
          Toast.error(res?.data?.removeMemberFromRole?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={isSuccessful ? 'Member Removed!' : 'Are you sure you want to remove this member?'}
        subText={isSuccessful ? 'Member has been removed successfully.' : 'Kindly provide reason for removing this member”, all users assigned to the role will be deactivated. If you are not sure, please cancel.'}
        actionBtnName="Yes, remove"
        handleModalAction={removeMemeberFromRole}
        topIcon={<div className={Styles.wrapper__icon}><RoundMinusIcon /></div>}
        isShow
        isActionBtnDisabled={!formValues?.reason || removeMemberLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={removeMemberLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={isSuccessful ? Styles.wrapper__okayBtn : Styles.wrapper__deactivateBtn}
      >
        {
          !isSuccessful && (
          <div className={Styles.wrapper__textInputContainer}>
            <TextInput name="reason" multiline rows={4} isRequired value={formValues?.reason} label="Reason" customOnChange={handleChange} width="100%" />
          </div>
          )
        }

      </AdminModal>
    </div>
  );
};

export default RemoveMemberRole;
